// eslint-disable-next-line node/no-missing-require
const { IssuesWrapper } = require('./src/components/IssuesWrapper');
exports.IssuesWrapper = IssuesWrapper;
